import { render, staticRenderFns } from "./ResourcesNavigation.vue?vue&type=template&id=bfd085bc&scoped=true"
import script from "./ResourcesNavigation.vue?vue&type=script&lang=ts"
export * from "./ResourcesNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd085bc",
  null
  
)

export default component.exports